<template>
    <div class="fab_field d-flex">
        <div class="d-flex">
            <a
                v-if="showupload"
                class="fab"
                @click="modal=true"
            >
                <i class="mdi mdi-paperclip"></i>
            </a>
        </div>
        <Badge
            v-if="success"
            class="badge align-self-end"
            @mouseover="hover=true"
            @mouseout="hover=false"
            @click="$emit('delete')"
        >{{hover ? 'x' : files.length}}</Badge>
        <div class="d-flex flex-grow-1">
            <textarea
                id="chatSend"
                v-model="message"
                :disabled="disabled"
                name="chat_message"
                :placeholder="$t('chat.send_placeholder')"
                class="chat_field chat_message"
                :maxlength="max"
                v-on:keyup.enter="e=> {e.shiftKey ? null : sendMessage()}"
            ></textarea>
        </div>
        <div class="d-flex">
            <a
                id="fab_send"
                class="fab"
                @click="sendMessage()"
            >
                <i class="mdi mdi-send"></i>
            </a>
        </div>
        <UploadDropzoneModal
            v-model="files"
            v-if="modal"
            :modal="modal"
            @close="modal=false"
            @success="onSuccess"
        ></UploadDropzoneModal>
    </div>
</template>

<script>

import Badge from '../../argon/components/Badge';
import UploadDropzoneModal from '../Common/Upload/UploadDropzoneModal';

export default {
    emits: ['delete', 'input', 'success', 'update:modelValue'],
    name: 'ChatForm',

    components: {
        Badge,
        UploadDropzoneModal,
    },

    props: {
        modelValue: {
            type: String,
            required: true,
        },
        send: {
            type: Function,
            required: true,
        },
        disabled: [Boolean, Number],
        showupload: Boolean,
        user: Object,
        max: Number,
        moderate: [Boolean, Number],
    },

    data() {
        return {
            modal: false,
            files: [],
            upload: null,
            hover: false,
            success: false,
        };
    },

    computed: {

        message: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
                this.$emit('input', value);
            },
        },
    },

    methods: {
        sendMessage() {
            try {
                this.message = /\S/.test(this.message) ? this.message : '';
                this.send();
                if (this.moderate) {
                    this.$notify({
                        message: this.$t('chat.message_waiting'),
                        type: 'success',
                    });
                }
                this.message = '';
            } catch (error) {
                this.$notify({
                    message: this.$t('chat.message_sent_error'),
                    type: 'danger',
                });
            }
        },
        onSuccess(e) {
            this.$emit('success', e);
            this.success = true;
            this.modal = false;
            this.$notify({
                message: 'Arquivo anexado',
                type: 'success',
            });
        },
        reset(keepMessage = true) {
            this.message = keepMessage ? this.message : '';
            this.success = false;
            this.files = [];
        },

    },
};
</script>

<style scoped>

    .badge {
        color: #fff;
        cursor: pointer;
        height: fit-content;
    }

    .chat_field {
        position: relative;
        margin: 5px 0 5px 0;
        width: 100%;
        font-family: 'Roboto';
        font-size: 12px;
        font-weight: 500;
        color: #4b4b4b;
        -webkit-font-smoothing: antialiased;
        border: none;
        outline: none;
        display: inline-block;
    }

    .chat_field.chat_message {
        height: 30px;
        resize: none;
        font-size: 13px;
        font-weight: 400;
    }

    .fab_field {
        width: 100%;
        display: inline-block;
        text-align: center;
        background: #fff;
        border-top: 1px solid #eee;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
    }

    .fab_field a {
        display: inline-block;
        text-align: center;
    }

    #fab_camera {
        float: left;
        background: rgba(0, 0, 0, 0);
    }

    #fab_send {
        float: right;
        background: rgba(0, 0, 0, 0);
    }

    .fab_field .fab {
        width: 35px;
        height: 35px;
        box-shadow: none;
        margin: 5px;
    }

    .fab_field .fab>i {
        font-size: 1.6em;
        line-height: 35px;
        color: #bbb;
    }

    .fab_field .fab>i:hover {
        color: #42a5f5;
    }

    /*Animation*/

    @-webkit-keyframes zoomIn {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

    @keyframes zoomIn {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 1;
        }
    }

    @-webkit-keyframes load {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        50% {
            -webkit-transform: scale(1.5);
            transform: scale(1.5);
            opacity: 1;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 0;
        }
    }

    @keyframes load {
        0% {
            -webkit-transform: scale(0);
            transform: scale(0);
            opacity: 0;
        }

        50% {
            -webkit-transform: scale(1.5);
            transform: scale(1.5);
            opacity: 1;
        }

        100% {
            -webkit-transform: scale(1);
            transform: scale(1);
            opacity: 0;
        }
    }

    /* SMARTPHONES PORTRAIT */

    @media only screen and (min-width: 300px) {
        .chat {
            width: 250px;
        }
    }

    /* SMARTPHONES LANDSCAPE */

    @media only screen and (min-width: 480px) {
        .chat {
            width: 300px;
        }
    }

    /* TABLETS PORTRAIT */

    @media only screen and (min-width: 768px) {
        .chat {
            width: 300px;
        }
    }

    /* TABLET LANDSCAPE / DESKTOP */

    @media only screen and (min-width: 1024px) {
        .chat {
            width: 300px;
        }
    }

    /*Color Options*/

    .blue .fab {
        background: #42a5f5;
        color: #fff;
    }

    .blue .chat {
        background: #42a5f5;
        color: #999;
    }

    /* Ripple */

    .ink {
        display: block;
        position: absolute;
        background: rgba(38, 50, 56, 0.4);
        border-radius: 100%;
        -moz-transform: scale(0);
        -ms-transform: scale(0);
        -webkit-transform: scale(0);
        transform: scale(0);
    }

    /*animation effect*/

    .ink.animate {
        -webkit-animation: ripple 0.5s ease-in-out;
        animation: ripple 0.5s ease-in-out;
    }

    @-webkit-keyframes ripple {

        100% {
            opacity: 0;
            -moz-transform: scale(5);
            -ms-transform: scale(5);
            webkit-transform: scale(5);
            -webkit-transform: scale(5);
            transform: scale(5);
        }
    }

    @keyframes ripple {

        100% {
            opacity: 0;
            -moz-transform: scale(5);
            -ms-transform: scale(5);
            webkit-transform: scale(5);
            -webkit-transform: scale(5);
            transform: scale(5);
        }
    }

    ::-webkit-input-placeholder {
        color: #bbb;
    }

    :-ms-input-placeholder {
        color: #bbb;
    }

    ::-moz-placeholder {
        color: #bbb;
    }

    :-moz-placeholder {
        color: #bbb;
    }

</style>
